import { NomadDB } from '~/db/NomadDB.js';

export const getFriendsService = (db: NomadDB) => {
  const findAll = async (): Promise<FriendSchema[]> => {
    return await db.friends.toArray();
  };

  const count = async (): Promise<number> => {
    return await db.friends.count();
  };

  return {
    findAll,
    count,
  };
};
